// Eye breaks come after every interval of work: the n-th starts n*interval +
// (n-1)*break seconds into the attempt. A break that cannot end before the
// exam does is skipped.
const breakStart = (n, intervalSec, breakSec) => n * intervalSec + (n - 1) * breakSec;

export function eyeBreakCount(totalSec, intervalSec, breakSec) {
  if (!intervalSec || !breakSec) return 0;
  let n = 0;
  while (breakStart(n + 1, intervalSec, breakSec) + breakSec < totalSec) n += 1;
  return n;
}

// Seconds left of the current break, or null outside a break.
export function breakSecondsLeft(elapsed, totalSec, intervalSec, breakSec) {
  for (let n = 1; ; n += 1) {
    const start = breakStart(n, intervalSec, breakSec);
    if (start + breakSec >= totalSec || elapsed < start) return null;
    if (elapsed < start + breakSec) return start + breakSec - elapsed;
  }
}
